// @ts-nocheck
import { RESOURCE_DETAIL_PAGE_KEY } from "../constants";

export default {
  pt: {
    [RESOURCE_DETAIL_PAGE_KEY]: {
      FREE_DOWNLOAD: "Baixe gratuitamente",
      DOWNLOADS: "Downloads",
      INFORMATION: "Informação",
      SUBSCRIBE: "Assine e tenha o melhor conteúdo em sua bandeja",
      SIGNUP: "Inscreva-se",
      RELATED_CONTENT: "Conteúdo Relacionado",
      TUTORIALS: "Sobre o tutorial",
      POST_BY: "Postado por",
      DIALOG_GET_PHONE_TITLE: "Entraremos em contacto",
      DIALOG_GET_PHONE_SUBTITLE:
        "Digite seu número de telefone para que te ajudemos a criar um plano de estudos, conversar sobre sua experiência ou fornecer promoções exclusivas.",
    },
  },
};
